<div class="container stage main_container">
    <h2>Reset Password</h2>
    <gol-loading-feedback *ngIf="shouldHideFrame"></gol-loading-feedback>
    <iframe id="b2cFrame" frameborder="0" [src]="b2cFrameSrc" width="100%" [height]="b2cFrameHeight" scrolling="no" 
        [ngClass]="{'loading': shouldHideFrame}"></iframe>
</div>